<script lang="ts">
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import {getLocalization} from 'core/svelte-context/context';
    import type {Downloadability, LoanRequestOption} from 'typings/portaro.be.types';
    import KpLink from 'shared/components/kp-link/KpLink.svelte';
    import LoanOptionPanelBody from './shared/LoanOptionPanelBody.svelte';

    export let option: LoanRequestOption<Downloadability>;

    const localize = getLocalization();
</script>

<KpGenericPanel>
    <strong slot="heading">
        {localize(/* @kp-localization loan.ElektronickaVerze */ 'loan.ElektronickaVerze')}
    </strong>

    <LoanOptionPanelBody>
        <div>
            {localize(/* @kp-localization loan.KnihaJeDostupnaElektronickyNaTechtoAdresach */ 'loan.KnihaJeDostupnaElektronickyNaTechtoAdresach')}
            <ul>
                {#each option.capability.links as link}
                    <li>
                        <KpLink {link}/>
                    </li>
                {/each}
            </ul>
        </div>
    </LoanOptionPanelBody>
</KpGenericPanel>

<style lang="less">
    li {
        word-break: break-word;
    }
</style>